import { MouseEventHandler } from 'react';
import { CurrentSlideButton } from '../CurrentSlideButton';
import { FirstSlideButton } from '../FirstSlideButton';
import { NextSlideButton } from '../NextSlideButton';
import { PrevSlideButton } from '../PrevSlideButton';

interface Props {
    localCurrentSlideNumber: number;
    currentSlideNumber: number;
    totalSlides: number;
    goToPrevSlide: MouseEventHandler<HTMLButtonElement>;
    goToNextSlide: MouseEventHandler<HTMLButtonElement>;
    goToCurrentSlide: MouseEventHandler<HTMLButtonElement>;
    goToLastSlide: MouseEventHandler<HTMLButtonElement>;
    goToFirstSlide: MouseEventHandler<HTMLButtonElement>;
    isSlidePreview?: boolean;
}

export const PresentationSlideNavigator = ({
    localCurrentSlideNumber,
    currentSlideNumber,
    totalSlides,
    goToPrevSlide,
    goToNextSlide,
    goToCurrentSlide,
    goToLastSlide,
    goToFirstSlide
}: Props) => {
    return (
        <>
            {localCurrentSlideNumber > 0 && (
                <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full group-hover:translate-x-0 transition-transform motion-reduce:transition-none duration-500 ease-out-quint">
                    <PrevSlideButton classNames="bg-primary/50 rounded-r-lg" onClick={goToPrevSlide} />
                </div>
            )}

            {localCurrentSlideNumber < currentSlideNumber && (
                <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full group-hover:translate-x-0 transition-transform motion-reduce:transition-none duration-500 ease-out-quint">
                    <NextSlideButton classNames="bg-primary/50 rounded-l-lg" onClick={goToNextSlide} />
                </div>
            )}

            {localCurrentSlideNumber !== 0 && (
                <div className="absolute right-[calc(50%+4px)] top-0 -translate-y-full group-hover:translate-y-0 transition-transform motion-reduce:transition-none duration-500 ease-out-quint">
                    <FirstSlideButton classNames="bg-primary/50 rounded-bl-lg rounded-br-s" onClick={goToFirstSlide} />
                </div>
            )}

            {localCurrentSlideNumber !== currentSlideNumber && localCurrentSlideNumber !== totalSlides - 1 && (
                <div className="absolute left-[calc(50%+4px)] top-0 -translate-y-full group-hover:translate-y-0 transition-transform motion-reduce:transition-none duration-500 ease-out-quint">
                    <CurrentSlideButton classNames="bg-primary/50 rounded-br-lg rounded-bl-s" onClick={goToCurrentSlide} />
                </div>
            )}
        </>
    );
};
